import { PHYSICAL_EXAM_SECTION_INITIAL_VALUES } from "./physical-exams";

export const GENERAL_APPEARANCE_FORM_INITIAL_VALUES = {
  sections: {
    generalAppearance: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
  },
  notes: "",
};

export type PhysicalExamGeneralAppearanceSections =
  keyof typeof GENERAL_APPEARANCE_FORM_INITIAL_VALUES.sections;
